export function getFormData(form: HTMLFormElement) {
    const formData = new FormData(form);
    const formObj = Object.fromEntries(formData.entries());
    Object.keys(formObj).forEach((key) => {
        if (formObj[key] === '') {
            formData.delete(key);
        }
    });
    return formData;
}
